<ng-container *transloco="let t">
  <div style="display: flex; justify-content: center">
    <mat-card class="lab-card">
      <div class="lab-header">
        <h2 class="title">{{ t('Results Hematology Analysis (Dog)') }}</h2>
      </div>

      <div class="lab-grid" [formGroup]="form">
        <div class="table full-table">
          <div class="table-title">{{ t('CBC Title') }}</div>
          <div class="table-head">
            <div class="cell head-analiza">{{ t('Parameter') }}</div>
            <div class="cell head-rezultat">{{ t('Result') }}</div>
            <div class="cell head-jedinica">{{ t('Unit') }}</div>
            <div class="cell head-ref">{{ t('RefValue') }}</div>
          </div>
          <div class="table-body">
            @for (p of leftParams; track p.control) {
              <div class="table-row">
                <div class="cell analiza">{{ t(p.labelKey) }}</div>
                <div class="cell rezultat">
                  <input
                    matInput
                    class="result-input"
                    [formControlName]="p.control"
                  />
                </div>
                <div class="cell jedinica">{{ unitMap[p.control] || '' }}</div>
                <div class="cell ref">{{ refMap[p.control] || '' }}</div>
              </div>
            }
          </div>
        </div>

        <div class="smear" [formGroup]="form">
          <label class="smear-label">{{ t('Blood smear') }}</label>
          <textarea class="smear-text" formControlName="bloodSmear"></textarea>
        </div>
        <div style="grid-column: 1 / -1; margin-top: 8px">
          <div class="table-row">
            <div class="cell analiza">
              {{ t('Veterinarian name and surname') }}
            </div>
            <div class="cell rezultat" style="grid-column: span 3">
              <input
                matInput
                class="result-input"
                formControlName="veterinarianName"
              />
            @if (form.get('veterinarianName')?.invalid && form.get('veterinarianName')?.touched) {
              <div class="mat-error" style="font-size:12px;color:#f44336">{{ t('This field is required') }}</div>
            }
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</ng-container>
